<div class="container-graphs">
  <div class="half-graph">
    <div class="graph">
      <div class="graph-title">
        <h1>Gênero</h1>
        <button
          mat-icon-button
          #tooltip="matTooltip"
          matTooltip=" Identidade de gênero das vítimas que relataram ocorrências."
          matTooltipPosition="below"
          matTooltipHideDelay="100"
          aria-label="Button that displays a tooltip that hides when scrolled out of the container"
          class="info-icon"
        >
          <img src="assets/icons/questionTooltip.svg" alt="" />
        </button>
      </div>
      <canvas
        [id]="elId + 'myChartGender'"
        style="max-height: 300px"
        *ngIf="!noGenderData"
      ></canvas>

      <div
        *ngIf="noGenderData"
        style="
          width: 100%;
          height: 300px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          border-radius: 16px;
          border: 2px dashed #c8bfff;

          color: #ab9fff;

          font-size: 1rem;
          font-weight: 400;
        "
      >
        <p>Não há dados suficientes para gerar o gráfico.</p>
      </div>
      <div
        style="
          width: 100%;
          display: flex;
          gap: 30px;
          flex-wrap: wrap;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <div style="display: flex; gap: 10px" *ngIf="!noGenderData">
          <div
            [style.background]="'#180064'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Cisgênero
          </p>
          <div
            [style.background]="'#9085DE'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Transgênero
          </p>
          <div
            [style.background]="'#5CDBBD'"
            style="width: 16px; height: 16px; border-radius: 4px"
          ></div>
          <p
            style="
              color: var(--material-theme-ref-neutral-neutral-60, #938f94);
              font-family: Roboto;
              font-size: 12px;
              font-style: normal;
              margin: 0;
              font-weight: 400;
              line-height: 16px;
            "
          >
            Não binário
          </p>
        </div>
      </div>
    </div>
    <div class="graph">
      <div class="graph-title">
        <h1>Etnia</h1>
        <button
          mat-icon-button
          #tooltip="matTooltip"
          matTooltip="Identificação racial das vítimas que relataram ocorrências."
          matTooltipPosition="below"
          matTooltipHideDelay="100"
          aria-label="Button that displays a tooltip that hides when scrolled out of the container"
          class="info-icon"
        >
          <img src="assets/icons/questionTooltip.svg" alt="" />
        </button>
      </div>
      <canvas
        [id]="elId + 'myChartCasesOfEtnia'"
        style="max-height: 300px"
        *ngIf="!noEtniaData"
      ></canvas>

      <div
        *ngIf="noEtniaData"
        style="
          width: 100%;
          height: 300px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          border-radius: 16px;
          border: 2px dashed #c8bfff;

          color: #ab9fff;

          font-size: 1rem;
          font-weight: 400;
        "
      >
        <p>Não há dados suficientes para gerar o gráfico.</p>
      </div>
      <div
        style="
          width: 100%;
          display: flex;
          gap: 30px;
          flex-wrap: wrap;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <div style="display: flex; gap: 10px">
          <div
            *ngFor="let color of dataSetColor"
            style="display: flex; gap: 10px"
          >
            <div
              [style.background]="color.backgroundColor"
              style="width: 16px; height: 16px; border-radius: 4px"
            ></div>
            <p
              style="
                color: var(--material-theme-ref-neutral-neutral-60, #938f94);
                font-family: Roboto;
                font-size: 12px;
                font-style: normal;
                margin: 0;
                font-weight: 400;
                line-height: 16px;
              "
            >
              {{ color.label }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="half-graph">
    <div class="graph">
      <div class="graph-title">
        <h1>Faixa Etária</h1>
        <button
          mat-icon-button
          #tooltip="matTooltip"
          matTooltip="Faixa etária das vítimas que relataram ocorrências."
          matTooltipPosition="below"
          matTooltipHideDelay="100"
          aria-label="Button that displays a tooltip that hides when scrolled out of the container"
          class="info-icon"
        >
          <img src="assets/icons/questionTooltip.svg" alt="" />
        </button>
      </div>
      <canvas
        [id]="elId + 'myChartAge'"
        style="max-height: 300px"
        *ngIf="!noAgeData"
      ></canvas>
      <div
        *ngIf="noAgeData"
        style="
          width: 100%;
          height: 300px;
          margin: 0 auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;

          border-radius: 16px;
          border: 2px dashed #c8bfff;

          color: #ab9fff;

          font-size: 1rem;
          font-weight: 400;
        "
      >
        <p>Não há dados suficientes para gerar o gráfico.</p>
      </div>
      <div
        style="
          width: 100%;
          display: flex;
          gap: 30px;
          flex-wrap: wrap;
          justify-content: center;
          margin-top: 20px;
        "
        *ngIf="!noAgeData"
      >
        <div style="display: flex; gap: 10px">
          <div
            *ngFor="let color of dataSetAge"
            style="display: flex; gap: 10px"
          >
            <div
              [style.background]="color.backgroundColor"
              style="width: 16px; height: 16px; border-radius: 4px"
            ></div>
            <p
              style="
                color: var(--material-theme-ref-neutral-neutral-60, #938f94);
                font-family: Roboto;
                font-size: 12px;
                font-style: normal;
                margin: 0;
                font-weight: 400;
                line-height: 16px;
              "
            >
              {{ color.label }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <!--
        <div class="graph">
            <div class="graph-title" style="padding-bottom: 0px;">
                <h1>Sexualidade</h1>
                <button mat-icon-button #tooltip="matTooltip"
                    matTooltip="Número de fotos e vídeos enviados pelos usuários."
                    matTooltipPosition="below" matTooltipHideDelay="100"
                    aria-label="Button that displays a tooltip that hides when scrolled out of the container"
                    class="info-icon">
                    <img src="assets/icons/questionTooltip.svg" alt="" />
                </button>
            </div>

        </div>
        -->
  </div>
</div>
